import react, { useEffect, useState } from 'react';


const LeadHistoryPopup = (props) => {
    const [userDetails, setUserDetails] = useState([]);


    useEffect(() => {
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            // console.log(userData);
            console.log(props.data);
        }
    }, []);



    return (
        <>
            <div className="dark-background">
                <div className='add-new-lead-popup'>

                    <div className='add-new-head'>
                        <h2> Lead Detials History <i className='fa fa-address-card'></i> </h2>
                        <i className='fa fa-times cross' onClick={props.close}></i>
                    </div>

                    <div className='lead-history'>

                        {
                            props.data.map((data) => {
                                return (
                                    <>
                                        <div className='history-item'>

                                            <div>

                                                <label> Date/Time </label>
                                                <p>{data.date + " / " + data.time}</p>

                                            </div>

                                            <div>
                                                <label> Client Name </label>
                                                <p>{data.client_name}</p>
                                            </div>

                                            <div>
                                                <label> Email </label>
                                                <p>{data.email}</p>
                                            </div>

                                            <div>
                                                <label> Business Name </label>
                                                <p>{data.business_name}</p>
                                            </div>

                                            <div>
                                                <label> Business Category </label>
                                                <p>{data.business_category}</p>
                                            </div>

                                            <div>
                                                <label> Website </label>
                                                <p>{data.website}</p>
                                            </div>

                                            <div>
                                                <label> GMB </label>
                                                <p>{data.gmb}</p>
                                            </div>

                                            <div>
                                                <label> Location </label>
                                                <p>{data.location}</p>
                                            </div>

                                            <div>
                                                <label> Work </label>
                                                <p>{data.work}</p>
                                            </div>

                                            <div style={{ "color": "var(--secondary" }}>
                                                <label> Updated By </label>
                                                <p>{data.name} ({data.designation})</p>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }

                    </div>
                </div>
            </div>
        </>
    );
}

export default LeadHistoryPopup;